module.exports = __webpack_public_path__ + "img/no-image.4e58b231.jpg";